export default __webpack_public_path__ + "static/media/Safed.63103f45.webp";